:host {
  display: inline-flex;
}

.badge {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  align-self: center;
  max-width: 100%;
  color: #ffffff;
  background-color: #3dcd58;
}

.badge *,
.badge *::before,
.badge *::after {
  box-sizing: inherit;
}

.badge--small {
  min-height: 20px;
  max-height: 34px;
  border-radius: 2px;
  padding: 1px 5px;
  line-height: 16px;
  font-size: 12px;
}

.badge--large {
  max-height: 60px;
  line-height: 30px;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 700;
}

.badge--new {
  background-color: #3dcd58;
}

.badge--featured {
  background-color: #42b4e6;
}

.badge--best-value {
  background-color: #ffd100;
  color: #0f0f0f;
}

.badge--best-performance {
  background-color: #e47f00;
}

.badge--best-seller {
  background-color: #b10043;
}